export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark'
};

// FOR LAYOUT 2 SECONDARY SIDEBAR
export const SECONDARY_SIDEBAR_GAP = 80;
export const SECONDARY_SIDEBAR_WIDTH = 215;